import React, { useEffect } from "react";
import NavArea from "../Home/Header/NavArea";
import { Button, Container, Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import Headroom from "react-headroom";
import AOS from "aos";
import "aos/dist/aos.css";
import bootstrapSkill from "../../images/skills/bootstrap-4.svg";
import react from "../../images/skills/react.svg";
import css from "../../images/skills/css3.svg";
import express from "../../images/skills/express.svg";
import firebase from "../../images/skills/firebase-logo.png";
import github from "../../images/skills/github.svg";
import html from "../../images/skills/html-5.svg";
import javascript from "../../images/skills/javascript.svg";
import materialUI from "../../images/skills/material-ui-1.svg";
import mongoDB from "../../images/skills/mongodb-logo.png";
import NodeJS from "../../images/skills/nodejs.svg";
import ReactStrap from "../../images/skills/react-bootstrap.svg";
import sass from "../../images/skills/sass-1.svg";
import git from "../../images/skills/git-icon.svg";
import typescript from "../../images/skills/typescript.svg";
import heroku from "../../images/skills/heroku.svg";
import redux from "../../images/skills/redux.svg";
import netlify from "../../images/skills/netlify-logo.png";

const Skills = [
  {
    name: "React",
    Photo: react,
  },
  {
    name: "Heroku",
    Photo: heroku,
  },
  {
    name: "Netlify",
    Photo: netlify,
  },
  {
    name: "Bootstrap",
    Photo: bootstrapSkill,
  },
  {
    name: "CSS",
    Photo: css,
  },
  {
    name: "Git",
    Photo: git,
  },
  {
    name: "Redux",
    Photo: redux,
  },
  {
    name: "NextJS",
    Photo: "https://cdn.auth0.com/blog/illustrations/nextjs.png",
  },
  {
    name: "Firebase",
    Photo: firebase,
  },
  {
    name: "ExpressJS",
    Photo: express,
  },

  {
    name: "Github",
    Photo: github,
  },
  {
    name: "MongoDB",
    Photo: mongoDB,
  },
  {
    name: "HTML",
    Photo: html,
  },
  {
    name: "Javascript",
    Photo: javascript,
  },
  {
    name: "MaterialUI",
    Photo: materialUI,
  },
  {
    name: "TypeScript",
    Photo: typescript,
  },
  {
    name: "SASS",
    Photo: sass,
  },
  {
    name: "React-Bootstrap",
    Photo: ReactStrap,
  },
  {
    name: "NodeJS",
    Photo: NodeJS,
  },
];

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 2200,
    });

    AOS.refreshHard();
  }, []);

  return (
    <section>
      <Headroom
        style={{
          webkitTransition: "all .5s ease-in-out",
          mozTransition: "all .5s ease-in-out",
          oTransition: "all .5s ease-in-out",
          transition: "all .5s ease-in-out",
          background: "#0a192f",
          boxShadow: "1px 1px 1px rgba(0,0,0,0.25)",
        }}
      >
        <Container>
          <NavArea />
        </Container>
      </Headroom>

      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Azim | | About</title>
          <meta name="description" content="Azim Uddin Ahamed details " />
        </Helmet>

        <Row className="my-5 text-center">
          <Col md={4}>
            <a
              href="https://drive.google.com/u/0/uc?id=1ZHnVz2BarpsaEHGm3sQXfo6wibyqc-65&export=download"
              target="_blank"
              rel="noreferrer"
              download
            >
              <Button className="mr-2 mb-2" outline color="dark">
                <i class="mr-2 fa fa-cloud-download">Download Resume</i>
              </Button>
            </a>

            <Link to="/contact">
              <Button className="ml-2 mb-2" outline color="danger">
                <i class="mr-2 fa fa-pencil-square-o"></i>
                Contact
              </Button>
            </Link>
          </Col>
          <Col lg={8}></Col>
        </Row>
        <Row
          style={{ borderBottom: "1px solid lightGray" }}
          className="my-5 text-center"
        >
          <Col md={4}>
            <h1>ABout Me</h1>
          </Col>
          <Col lg={8}>
            <p>
              Front-End Web Developer using&nbsp;React.js with a decent
              knowledge
              <br />
              of the backend&nbsp;technology like Node.js, Express.js, MongoDB,
              REST-API,
              <br />
              JSON, Firebase, Debugging and more.
            </p>
          </Col>
        </Row>
        <Row
          style={{ borderBottom: "1px solid lightGray" }}
          className="my-5 text-center"
        >
          <Col md={4}>
            <h1>Skills</h1>
          </Col>
          <Col lg={8}>
            <Row>
              {Skills.map((item, i) => (
                <Col
                  style={{ borderBottom: "2px solid lightGray" }}
                  key={i}
                  xs={6}
                  sm={6}
                  md={3}
                  className="pb-2"
                >
                  <h5 className="my-3">{item.name}</h5>
                  <img
                    width="100"
                    className="pr-2 mr-2"
                    style={{
                      height: "80px",
                      borderRight: "2px solid lightGray",
                    }}
                    src={item.Photo}
                    alt=""
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </section>
  );
};

export default About;
